// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NLQSaveDashBoardPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { PureComponent } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import actions from './Izenda.NLQSaveDashBoardPopupActions';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import appStore from 'logic/Izenda.AppStore';
import { set, get,flow, filter, head, isNil } from 'lodash/fp';
import uiState from 'logic/Izenda.UiState';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
const INTERVAL = 500;

@connect(actions) 
class NLQSaveDashBoardPopup extends PureComponent {

   componentDidMount() {
    const { dashboardName, reportType, categoryId, subCategoryId, isGlobal } = this.props.model;
    appStore.loadCategorySettings().then(result => {
      this.props.updateComponentState(set('localGlobalCategories', result));
    });
    this.props.updateOriginalState({
      dashboardName,
      reportType,
      categoryId,
      subCategoryId,
      isGlobal
    });
    this.callNLQAPI(this.props, null, this);
  }

  componentWillUnmount(){
    uiState.resetCheckDirtyFunction();
  }

  callNLQAPI = async (props,catId,self) => {
    const { exploreStore } = props;
    const { isGlobal } = props.model;
    const categoryData = catId === null ? null :  catId;
    const newCatCheck = 'new_';
    if(catId && catId.includes(newCatCheck)){
      self.addnewDashboardAction(props);
      return;
    }
    await exploreStore.loadDashboardListNLQ( `${categoryData}` ,isGlobal);
    const { storeDashboard : { model : {items :{categories}} }} = exploreStore;
    if (categories && categories.length > 0){
      self.getDashboardList(categories);
    }  else {
      self.addnewDashboardAction(props);
    }
  }

  addnewDashboardAction = (props) => {
    const blankArray = [];
    const { addNewDashboardList } = props;
     setTimeout(() => {
      addNewDashboardList(blankArray);
    }, INTERVAL);
  }
  
  getDashboardList = (globalLocalCategories,categoryname = null) => {
    var dashboardList = [];
    var globalLocalList = globalLocalCategories[0].subCategories.filter(x=>{
      return x.name == categoryname || x.name;
    });
    dashboardList  = globalLocalList[0].subCategories[0].dashboards;
    let list = [];
    dashboardList.filter(function(elem) {
      return list.push({'id': elem.id, 'name': elem.name});
    });
    this.props.addNewDashboardList(list);
    return dashboardList;
  }

  getSaveInCategory = (isGlobal: boolean, localGlobalCategories: any) => {
    return flow(filter({ isGlobal: isGlobal }), head)(localGlobalCategories);
  };

  getSelectedCategory = (model: any) => {
    return isNil(model.categoryId) ? null : { id: model.categoryId, name: model.categoryName };
  };

  getSelectedDashboard = (model: any) => {
    return isNil(model.id) ? null : { id: model.id, name: model.name };
   };

    /**
   * Check to display Save Into component.
   */
  doesShowSaveInto = () => isNil(uiState.tenantId) && !!uiState.currentUser.systemAdmin;

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangeSaveInHandler = (value) => {
    const { changeSaveInHandler } = this.props;
    changeSaveInHandler(value);
    this.callNLQAPI(this.props, null, this);
  };

  onChangeCategoryHandler = (key, value) => {
    const { changeCategoryHandler } = this.props;
    changeCategoryHandler(key, value);
    this.callNLQAPI(this.props, key, this);
  };
  
  renderContainer = () => {
    const props = this.props;
    const {
      localizer,
      authorization,
      selectedDashboardErrorCls,
      selectedDashboardErrorMsg, 
      reportName,
      model,
      componentState,
      authorizationConstants: { PERMISSION_KEY },
      popupConfig,
      getCategories,
      searchCategoryDataHandler,
      resetCategory,
      changeDashboardHandler,
      onFocusDashboardHandler
    } = this.props;
        // process to create temp category type id
        const selectedSaveInto = get('id', this.getSaveInCategory(model.isGlobal, componentState.localGlobalCategories));
        const hasPrivilege = authorization.checkPrivileges([PERMISSION_KEY.DashboardsCanCreateNewCategoryValue]);

        const selectedCategory = this.getSelectedCategory(model);
        const selectedDashboard = this.getSelectedDashboard(model);
        let selectCategoryHint = localizer.getText('REPORTDESIGNER_MESSAGE_HINT_CATEGORY');
        let selectDashboardHint = localizer.getText('REPORTDESIGNER_DASHBOARD_MESSAGE_HINT_CATEGORY');
        let addNewCategory = props.addNewCategoryHandler;
        let addNewDashboard = props.addNewDashboardHandler;
        if (!hasPrivilege) {
          addNewCategory = () => false;
          selectCategoryHint = null;
        }
    let selectedDashboardNameErrorCls = selectedDashboardErrorCls ?  'error-text dashboard-error-text': ' ';
    return (
      <GridLayout className='form-horizontal nlq-form nlq-dashboard'>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            <div className='labtxt'>{'Report Name'}</div>
            <input type='text' name='title' defaultValue={reportName} readOnly={true} className='title_txtbox'  />
          </GridLayout.Col>
        </GridLayout.Row>
        {this.doesShowSaveInto() && (
          <GridLayout.Row>
            <GridLayout.Col cols="12">
            <div className='labtxt'>{localizer.getText('NLQ_SAVE_POPUP_SAVE_TO')}</div>
              <Select
                options={componentState.localGlobalCategories}
                labelKey="name"
                valueKey="id"
                value={selectedSaveInto}
                onChange={this.onChangeSaveInHandler}
                scalable={false}
                textboxMode={false}
              />
            </GridLayout.Col>
          </GridLayout.Row>
        )}
        <GridLayout.Row>
          <GridLayout.Col cols="12">
          <div className='labtxt'>{popupConfig.CATEGORY}</div>
            <Select
              simpleValue
              options={componentState.categories}
              labelKey="name"
              valueKey="id"
              value={selectedCategory}
              noResultsText={selectCategoryHint}
              onChange={this.onChangeCategoryHandler}
              onAddNew={addNewCategory}
              isLazyLoading
              getData={getCategories}
              onSearchLazy={searchCategoryDataHandler}
              onCloseMenu={resetCategory}
            />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row>
          <GridLayout.Col cols="12">
           <div className='labtxt'>{popupConfig.DASHBOARD_NAME}</div>
           <div className={selectedDashboardNameErrorCls}>
            {selectedDashboardErrorMsg &&  <span className="error-report-message-name error-dashboard-message-name">{selectedDashboardErrorMsg}</span> }
           <Select
              simpleValue
              options={componentState.dashboardListData}
              labelKey="name"
              valueKey="id"
              value={selectedDashboard}
               noResultsText={selectDashboardHint}
               onChange={changeDashboardHandler}
               onFocus={onFocusDashboardHandler}
               onAddNew={addNewDashboard}
            /> 
            </div>
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    );
  };

  render() {
    const { onClosing, localization } = this.props;
    const popupTitle = localization.getText('COMMON_LABEL_DASHBOARD_NAME');
    return (
      <Popup visible onClosing={onClosing} autoClose={false} type='none' sizeClass='explore-modal'>
        <Popup.Header title={popupTitle} />
        <Popup.Body>{this.renderContainer()}</Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton type='accept'>{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
          <Popup.ConfirmationButton type='cancel'>
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default NLQSaveDashBoardPopup;



// WEBPACK FOOTER //
// ./ui/share/components/controls/NLQSaveDashBoardPopup/Izenda.NLQSaveDashBoardPopup.js